import { useState } from "react";
import { AsyncThrottler } from "@tanstack/pacer/async-throttler";
import { bindInstanceMethods } from "@tanstack/pacer/utils";
function useAsyncThrottler(fn, options) {
  const [asyncThrottler] = useState(
    () => bindInstanceMethods(new AsyncThrottler(fn, options))
  );
  asyncThrottler.setOptions(options);
  return asyncThrottler;
}
export {
  useAsyncThrottler
};
//# sourceMappingURL=useAsyncThrottler.js.map
